/// <amd-module name="typeahead/features/UnspecifiedAreaRequestParamModifier" />

/*
 * UnspecifiedAreaRequestParamModifier may need to be removed in future since it is not longer used
 * */
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [{
    lobs: ["NONE"],
}];

const featureFlag = "unspecified_area";

export class UnspecifiedAreaRequestParamModifier implements IRequestUrlParamModifier {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            JQueryPromise<ISuggestServiceQueryParams> {
        return addFeatureFlag(featureFlag, configuration, params, context, options);
    }
}
